BatchGeoStore.addReducer("UserLocation", function (state, action) {
  state = state || {
    active: false,
    cycle: 0, // 0 - enabled, 1 - follow, 2 - disabled
    hasPanned: false,
    lastUpdated: new Date().getTime(),
    latitude: null,
    longitude: null,
    accuracy: null,
  };

  switch (action.type) {
    case "USER_LOCATION_ACTIVE_TOGGLE":
      return Object.assign({}, state, {
        active: !state.active,
      });

    case "USER_LOCATION_ACTIVE_ENABLE":
      return Object.assign({}, state, {
        active: true,
        hasPanned: false,
      });

    case "USER_LOCATION_ACTIVE_DISABLE":
      return Object.assign({}, state, {
        active: false,
        hasPanned: false,
        latitude: null,
        longitude: null,
        accuracy: null,
      });

    case "USER_LOCATION_ACTIVE_CYCLE": {
      // Start cycle out as the value from the action to allow it to be set manually
      var cycle = action.cycle;
      var validCycleValues = [0, 1, 2];
      // If the cycle value isn't in our array, default to adding 1 or reseting to 0
      if (validCycleValues.indexOf(cycle) === -1) {
        cycle = state.cycle === 2 ? 0 : state.cycle + 1;
      }
      return Object.assign({}, state, {
        cycle: cycle,
      });
    }

    case "USER_LOCATION_PANNED":
      return Object.assign({}, state, {
        hasPanned: action.hasPanned,
      });

    case "USER_LOCATION_LOCATION_UPDATE":
      return Object.assign({}, state, {
        lastUpdated: new Date().getTime(),
        latitude: action.latitude,
        longitude: action.longitude,
        accuracy: action.accuracy,
      });

    default:
      return state;
  }
});
